// src/app/speech-recognition.service.ts

import { Injectable, NgZone, inject } from '@angular/core';
import { AppProperty } from '../properties/app.property';

@Injectable({
  providedIn: 'root',
})
export class SpeechRecognitionService {
  private zone = inject(NgZone);
  private appProperty = inject(AppProperty);

  private recognition: any;
  private inactivityTimer: any;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    const { webkitSpeechRecognition }: IWindow = window as any;

    if (webkitSpeechRecognition) {
      this.recognition = new webkitSpeechRecognition();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = 'it-IT';

      this.recognition.onresult = (event: any) => {
        this.zone.run(() => {
          const transcript = event.results[event.resultIndex][0].transcript.trim();
          // console.log(`Transcript: ${transcript}`);
          this.appProperty.assistantUserMessage = transcript;
          this.resetInactivityTimer(); // Resetta il timer di inattività
          // Puoi fare qualcosa con il testo trascritto qui
        });
      };

      this.recognition.onerror = (event: any) => {
        console.error(`Speech Recognition Error: ${event.error}`);
        // Gestisci l'errore qui
      };

      this.recognition.onend = () => {
        this.appProperty.setRecordingState(false);
        console.log('Recognition ended.');
        // Gestisci la fine del riconoscimento qui se necessario
      };
    } else {
      console.warn('Web Speech API non supportata nel browser');
    }
  }

  startListening(): void {
    if (this.recognition && !this.appProperty.recordingState) {
      this.appProperty.assistantUserMessage = '';
      this.recognition.start();
      this.appProperty.setRecordingState(true)
      this.resetInactivityTimer(); // Inizia il timer di inattività
    }
  }

  stopListening(): void {
    if (this.recognition && this.appProperty.recordingState) {
      this.recognition.stop();
      this.appProperty.setRecordingState(false)
      clearTimeout(this.inactivityTimer); // Ferma il timer di inattività
    }
  }

  resetInactivityTimer(): void {
    clearTimeout(this.inactivityTimer); // Pulisci il timer esistente
    this.inactivityTimer = setTimeout(() => {
      this.stopListening();
    }, 4000);
  }

  updateLanguage(language: string): void {
    if (this.recognition && language)
      this.recognition.lang = language;
  }

  isSpeechRecognitionAvailable(): boolean {
    return !!this.recognition;
  }
}

interface IWindow extends Window {
  webkitSpeechRecognition: any;
}
